import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NotesPanelComponent } from './components/notes-panel/notes-panel.component';
import { NoteCardComponent } from './components/note-card/note-card.component';
import { NoteEditorComponent } from './components/note-editor/note-editor.component';
import { NotesService } from './services/notes.service';

@NgModule({
  declarations: [
    NotesPanelComponent,
    NoteCardComponent,
    NoteEditorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
  ],
  exports: [
    NotesPanelComponent,
    NoteCardComponent,
    NoteEditorComponent,
  ],
  providers: [
    NotesService,
  ],
})
export class NotesModule {}